import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";
import StagedAccessorialsTable from "../StagedAccessorialsTable/StagedAccessorialsTable";
import PrimaryButton from "../../../../../Buttons/PrimaryButton/PrimaryButton";
import SecondaryButton from "../../../../../Buttons/SecondaryButton/SecondaryButton";
import { getSumOfArrayOfObjects } from "../../../../../../utils/calcHelpers";
import { handleAltEnter } from "../../../../../../utils/keyboardShortcutHelpers";

export default function AccessorialsStepTwo({
  stagedAccessorialsArray,
  setAccessorialToEdit,
  setStep,
  handleDeleteAccessorial,
  handleUpdateAccessorial,
  handleClose,
  allSubmitted,
  setAllSubmitted,
  setAddNew,
  deleteModalOpen,
  setDeleteModalOpen
}) {
  const [submitAll, setSubmitAll] = useState(false);
  const [totals, setTotals] = useState({});

  const handleAddNew = () => {
    setAccessorialToEdit({});
    setAddNew(true);
    setStep(1);
  };

  useEffect(() => {
    if (!stagedAccessorialsArray.some(a => !a.submitted)) {
      setAllSubmitted(true);
      setSubmitAll(false);
    } else {
      setAllSubmitted(false);
    }

    setTotals({
      carrierCost: getSumOfArrayOfObjects(stagedAccessorialsArray, "amount"),
      carrierTotal: getSumOfArrayOfObjects(stagedAccessorialsArray, "totalAmount")
    });
  }, [stagedAccessorialsArray]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (allSubmitted && !deleteModalOpen) {
        handleAltEnter(e, false, handleClose);
      } else if (!deleteModalOpen) {
        handleAltEnter(e, submitAll, setSubmitAll, true);
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return function cleanup() {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [allSubmitted, submitAll, deleteModalOpen]);

  return (
    <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
      <StagedAccessorialsTable
        stagedAccessorialsArray={stagedAccessorialsArray}
        setAccessorialToEdit={setAccessorialToEdit}
        handleDeleteAccessorial={handleDeleteAccessorial}
        setStep={setStep}
        submitAll={submitAll}
        handleUpdateAccessorial={handleUpdateAccessorial}
        totals={totals}
        setDeleteModalOpen={setDeleteModalOpen}
      />
      <Box className="Accessorial-modal-form-row" sx={{ display: "flex", marginTop: "50px" }}>
        <Box sx={{ margin: "0 20px 0 auto" }}>
          <SecondaryButton
            label="Add Accessorial"
            onClick={handleAddNew}
            disabled={submitAll}
          />
        </Box>
        <Box>
          {allSubmitted ? (
            <PrimaryButton
              label="Finish"
              onClick={handleClose}
            />
          ) : (
            <PrimaryButton
              label="Submit All"
              onClick={() => setSubmitAll(true)}
              disabled={submitAll}
            />
          )}
        </Box>
      </Box>
    </Box>
  );
}

AccessorialsStepTwo.propTypes = {
  stagedAccessorialsArray: PropTypes.array.isRequired,
  setAccessorialToEdit: PropTypes.func.isRequired,
  setStep: PropTypes.func.isRequired,
  handleDeleteAccessorial: PropTypes.func.isRequired,
  handleUpdateAccessorial: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  allSubmitted: PropTypes.bool.isRequired,
  setAllSubmitted: PropTypes.func.isRequired,
  setAddNew: PropTypes.func.isRequired,
  deleteModalOpen: PropTypes.bool,
  setDeleteModalOpen: PropTypes.func.isRequired
};